// import React, { useState } from 'react';
// import { PinContainer } from './ProjectCard';
// import { motion } from 'framer-motion';
// import { LampContainer } from './LampContainer';
// import Modal from './Modal'; // Uncomment or adjust as needed

// function ProjectsScreen() {
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [modalContent, setModalContent] = useState('');
//   const [clickPosition, setClickPosition] = useState({ x: 0, y: 0 });

//   const cardVariants = [
//     {
//       id: 1,
//       children: (
//         <div
//           onClick={() => {
//             setIsModalOpen(true);
//             setModalContent('arapp');
//           }}
//           className='reveal arapp'
//         />
//       ),
//       title: 'AR App',
//       modalContent: 'arapp',
//     },
//     {
//       id: 2,
//       children: (
//         <div
//           onClick={() => {
//             setIsModalOpen(true);
//             setModalContent('subkontrakt');
//           }}
//           className='reveal subkontrakt'
//         />
//       ),
//       title: 'Advertising site',
//       modalContent: 'subkontrakt',
//     },
//     {
//       id: 3,
//       children: (
//         <div
//           onClick={() => {
//             setIsModalOpen(true);
//             setModalContent('todoapp');
//           }}
//           className='reveal todoapp'
//         />
//       ),
//       title: 'Todo app',
//       modalContent: 'todoapp',
//     },
//     {
//       id: 4,
//       children: (
//         <div
//           onClick={() => {
//             setIsModalOpen(true);
//             setModalContent('onlinelaunch');
//           }}
//           className='reveal onlinelaunch'
//         />
//       ),
//       title: 'Client website',
//       modalContent: 'onlinelaunch',
//     },
//     {
//       id: 5,
//       children: (
//         <div
//           onClick={() => {
//             setIsModalOpen(true);
//             setModalContent('calculator');
//           }}
//           className='reveal calculator'
//         />
//       ),
//       title: 'Simple Calculator',
//       modalContent: 'calculator',
//     },
//   ];
//   const handleCardClick = (content: any, clientX: any, clientY: any) => {
//     setClickPosition({ x: clientX, y: clientY });
//     setModalContent(content);
//     setIsModalOpen(true);
//   };
//   const modalVariants = {
//     hidden: {
//       opacity: 0,
//       transition: { duration: 0.5 },
//     },
//     visible: {
//       opacity: 1,

//       zIndex: 999,
//       transition: { duration: 0.5 },
//     },
//     containerHidden: {
//       opacity: 0,
//       zIndex: -10000000,
//       transition: { duration: 0.5 },
//     },
//     containerVisible: {
//       opacity: 1,
//       zIndex: 888,
//       transition: { duration: 0.5 },
//     },
//   };

//   return (
//     <LampContainer>
//       <motion.div
//         initial={{ opacity: 0.5, y: 0 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         transition={{
//           delay: 0.3,
//           duration: 0.8,
//           ease: 'easeInOut',
//         }}
//         className='h-full overflow-scroll absolute -top-[40vh] pb-[20vh] w-screen min-h-screen xl:overflow-hidden xl:relative xl:top-0 xl:pb-0 z-50 mt-8 bg-gradient-to-br bg-transparent py-4 bg-clip-text flex flex-row flex-wrap items-center justify-center'
//       >
//         {cardVariants.map(Card => (
//           <div
//             key={Card.id}
//             onClick={e => {
//               handleCardClick(Card.modalContent, e.clientX, e.clientY);
//               console.log(e);
//             }}
//             className={
//               Card.title === 'Simple Calculator'
//                 ? 'mb-[10dvh] sm:mb-0'
//                 : 'mb-[-10dvh] sm:mb-0'
//             }
//           >
//             <PinContainer children={Card.children} title={Card.title} />
//           </div>
//         ))}
//       </motion.div>
//       <motion.div
//         animate={isModalOpen ? 'containerVisible' : 'containerHidden'}
//         className={
//           'w-screen h-screen fixed top-0 left-[200vw] bg-[#0000007a] -z-50 cursor-pointer'
//         }
//         variants={modalVariants}
//         onClick={() => setIsModalOpen(false)}
//       ></motion.div>
//       <motion.div
//         initial='hidden'
//         animate={isModalOpen ? 'visible' : 'hidden'}
//         className='absolute -top-[100dvh] sm:top-1/2  left-1/2 flex items-center justify-center bg-white -z-[999] rounded-2xl  shadow-2xl shadow-[#0c6876] translate-y-[70%] sm:-translate-y-1/2 -translate-x-1/2 '
//         variants={modalVariants}
//         // onClick={() => setIsModalOpen(true)}
//       >
//         <Modal modalContent={modalContent} setIsModalOpen={setIsModalOpen} />
//       </motion.div>
//     </LampContainer>
//   );
// }

// export default ProjectsScreen;

import GitHubIcon from '../assets/svgs/githubIcon';
import MonitorMockup from '../assets/svgs/monitorMockup';
import WebLinkIcon from '../assets/svgs/webLinkIcon';
import { LampContainer } from './LampContainer';
import MobileMockup from './MobileMockup';
import Calculator from './projects/calculator/Calculator';
import { projectData } from './projects/projectsData';
function ProjectsScreen() {
  return (
    <LampContainer className='h-auto'>
      <div className=' w-full h-full mt-10 px-[5%] overflow-y-scroll'>
        <h2 className='text-white text-[45px] text-center'>My work</h2>
        <div className='flex-col tablet:[&>*:nth-child(odd)]:flex-row-reverse  pb-32'>
          {projectData.map(Project => (
            <div
              key={Project.id}
              className='flex flex-col tablet:flex-row gap-5 tablet:gap-10 mt-20 mb-5 tablet:my-20 justify-between'
            >
              <div
                className={
                  Project.interactiveContent.type === 'component' ||
                  Project.interactiveContent.title === 'ArApp' ||
                  window.innerWidth <= 1023
                    ? 'w-auto h-auto flex flex-col'
                    : 'w-1/3 h-auto flex flex-col'
                }
              >
                <h3 className='text-white text-3xl mb-5 tablet:mb-8'>
                  {Project.title}
                </h3>
                {Project.content.map(ProjectContent => (
                  <p className='text-white text-xl my-3 tablet:my-5'>
                    {ProjectContent}
                  </p>
                ))}
                <div className='flex flex-row gap-10 items-center mt-5 mb-0 tablet:mt-10'>
                  {Project.links.map(ProjectLinks => (
                    <a
                      href={ProjectLinks.href}
                      target='_blank'
                      rel='noreferrer'
                      className='text-white text-xl pointer w-fit'
                    >
                      {ProjectLinks.text === 'GitHub' ? (
                        <GitHubIcon width='3rem' height='3rem' fill='#FFF' />
                      ) : (
                        <WebLinkIcon width='3rem' height='3rem' fill='#FFF' />
                      )}
                    </a>
                  ))}
                </div>
              </div>
              <div
                className={
                  Project.interactiveContent.type === 'component' ||
                  Project.interactiveContent.title === 'ArApp' ||
                  window.innerWidth <= 1023
                    ? `w-full max-w-full sm:w-[400px] mx-auto tablet:mx-0 `
                    : 'w-2/3'
                }
              >
                {Project.interactiveContent.type === 'component' ||
                Project.interactiveContent.title === 'ArApp' ? (
                  <MobileMockup>
                    {Project.interactiveContent.title === 'ArApp' ? (
                      <iframe
                        src={Project.interactiveContent.src}
                        title={Project.interactiveContent.title}
                        className='w-full h-full mx-auto'
                      ></iframe>
                    ) : (
                      <Calculator />
                    )}
                  </MobileMockup>
                ) : window.innerWidth <= 1023 ? (
                  <MobileMockup
                    children={
                      <iframe
                        src={Project.interactiveContent.src}
                        title={Project.interactiveContent.title}
                        className='w-full h-full mx-auto'
                      ></iframe>
                    }
                  />
                ) : (
                  <MonitorMockup
                    width='100%'
                    height='100%'
                    children={
                      <iframe
                        src={Project.interactiveContent.src}
                        title={Project.interactiveContent.title}
                        className='w-full h-full mx-auto'
                      ></iframe>
                    }
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </LampContainer>
  );
}

export default ProjectsScreen;
